import { render } from "./NavigationMain.vue?vue&type=template&id=efefaf64"
import script from "./NavigationMain.vue?vue&type=script&lang=js"
export * from "./NavigationMain.vue?vue&type=script&lang=js"

import "./index.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "C:\\Users\\chervinskii_mk\\Documents\\ORIS\\Repositories\\site\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__